import api from './api';

/**
 * Obtener todas las conversiones
 */
export const getConversions = async (params = {}) => {
  try {
    const response = await api.get('/configuration/conversions', { params });
    return response.data;
  } catch (error) {
    console.error('Error al obtener conversiones:', error);
    throw error;
  }
};

/**
 * Obtener una conversión por ID
 */
export const getConversion = async (id) => {
  try {
    const response = await api.get(`/configuration/conversions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener conversión:', error);
    throw error;
  }
};

/**
 * Crear una nueva conversión
 */
export const createConversion = async (conversionData) => {
  try {
    const response = await api.post('/configuration/conversions', conversionData);
    return response.data;
  } catch (error) {
    console.error('Error al crear conversión:', error);
    throw error;
  }
};

/**
 * Actualizar una conversión
 */
export const updateConversion = async (id, conversionData) => {
  try {
    const response = await api.put(`/configuration/conversions/${id}`, conversionData);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar conversión:', error);
    throw error;
  }
};

/**
 * Eliminar una conversión
 */
export const deleteConversion = async (id) => {
  try {
    const response = await api.delete(`/configuration/conversions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar conversión:', error);
    throw error;
  }
};

